<template> 
  <!--todo: inserire gestione pagine del b2b associandole con lo shop afvweb-->
  <router-view/>
</template>